<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18 12c0-4.5-1.92-8.74-6-10a10 10 0 0 0 0 20c4.08-1.26 6-5.5 6-10Z"/></svg>